import CTA from "../components/public/CTA";
import FAQSection from "../components/public/FAQSection";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";

export function HowItWorks() {
  const steps = [
    [
      "Tell us what you need",
      "Choose a service or send the context in your own words.",
    ],
    [
      "We shape the plan",
      "Our team clarifies the brief, scope, documents, timing and likely milestones.",
    ],
    [
      "You approve the route",
      "Review the plan and pricing before any execution begins.",
    ],
    [
      "Track the work",
      "Follow status, messages, documents and evidence in one secure place.",
    ],
    [
      "Confirm completion",
      "Receive the completed service, close the order and share your experience.",
    ],
  ];
  return (
    <>
      <PageHero
        eyebrow="How it works"
        title="Simple for you. Thorough behind the scenes."
        copy="The Bridge is designed to make complex local execution feel calm and accountable."
      />
      <section id="content" className="section-space bg-white">
        <div className="container max-w-4xl">
          <div className="relative space-y-5 before:absolute before:bottom-8 before:left-6 before:top-8 before:w-px before:bg-ocean/20 sm:before:left-7">
            {steps.map(([title, copy], index) => (
              <Reveal key={title} delay={index * 50}>
                <div className="relative flex gap-5 rounded-3xl border border-ink/10 bg-white p-6 shadow-sm sm:gap-7">
                  <span className="relative z-10 grid h-12 w-12 shrink-0 place-items-center rounded-full bg-ink font-display font-bold text-cyan">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h2 className="font-display text-xl font-bold text-ink">
                      {title}
                    </h2>
                    <p className="mt-2 text-sm leading-7 text-slate">{copy}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <FAQSection />
      <CTA />
    </>
  );
}
